import jwtDecode from 'jwt-decode'

import { $host } from '@App/api'
import { getDataWrapper } from '@App/api/helper'
import authCookieManager from '@App/cookies/auth_cookie_manager'
import {
  ILoginError,
  ILoginResult, ILoginSuccess,
  IRegisterData,
  IRegisterResponse,
} from '@App/redux/slices/user/types'

import { IChangePasswordDataRequest, IJwtDecodeData, IResetDataRequest } from '@Interfaces/CommonInterfaces'

export const login = async (email: string, password: string, verification_code: number | null = null) => {
  try {
    const loginData: {
      username: string
      password: string
      verification_code?: number
    } = { username: email, password }

    if (verification_code) {
      loginData['verification_code'] = verification_code
    }

    const { data } = await $host.post('InternalApi/user/login', loginData)

    if (data.login === 0 && data.status === 0) {
      return data
    }

    const jwtDecodeData = jwtDecode<IJwtDecodeData>(data.data.access_token)

    if (data.data.access_token) {
      authCookieManager.setAccessToken(data.data.access_token)
      localStorage.setItem('user_agent', data.data.user_agent)
      localStorage.setItem('user_session', data.data.user_session)
      localStorage.setItem('ip', data.data.ip)
    } else {
      return { status: false, message: 'Invalid token', ...data }
    }
    return {
      ...jwtDecodeData,
      access_token: data.data.access_token,
      refresh_token: data.data.refresh_token,
      user_agent: data.data.user_agent,
      user_session: data.data.user_session,
      username: data.data.username,
      ip: data.data.ip,
      raw: data.data,
    }

  } catch (e: any) {
    return { status: false, message: e.response.data.message, data: e.response.data?.data }
  }
}

export const check = async () => {
  const { data } = await $host.get('InternalApi/me')

  if (!data) {
    authCookieManager.setAccessToken('')
    return {
      token: null,
      user_info: null,
    }
  } else {
    return {
      token: authCookieManager.getAccessToken(),
      user_info: data.data,
    }
  }
}

export const refreshToken = async () => {
  try {
    const { data } = await $host.post('InternalApi/user/refresh', {})

    if (data.data.access_token && data.data.refresh_token) {
      authCookieManager.setAccessToken(data.data.access_token)
      authCookieManager.setRefreshToken(data.data.refresh_token)
      return data
    }
    return null
  } catch (e) {
    return null
  }
}

export const resetPassLink = async (email: string) => {
  try {
    const response = await getDataWrapper($host.post('api/auth/forgot-password', { email }))

    return { ...(response as Object), status: true }
  } catch (e: any) {
    return { ...e.response, status: false }
  }
}

export const resetPass = async (params: IResetDataRequest) => {
  try {
    return await getDataWrapper($host.post('api/auth/reset-password', params))
  } catch (e: any) {
    return e.response.data.message
  }
}

export const register = async (payload: IRegisterData) => {
  try {
    const { data }: { data: IRegisterResponse } = await $host.post('InternalApi/user/register', payload)

    return data
  } catch (e: any) {
    return e.response.data.message
  }
}

export const logoutPost = async () => {
  const data = await $host.post('InternalApi/user/logout', {})

  if (data) {
    authCookieManager.clearTokenCookie()
  }

  return data
}

export const changePassword = async (params: IChangePasswordDataRequest) => {
  try {
    return await getDataWrapper($host.post('api/auth/change-password', params))
  } catch (e: any) {
    return e.response.data.message
  }
}
